import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import Layout from "../components/Layout";
import { Card, CardHeader, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";

const NewCollaborator = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [managers, setManagers] = useState([]);

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    department_id: "",
    department: "",
    cost_center: "",
    job_title: "",
    manager_id: "",
    country: "",
    birth_date: "",
    hire_date: "",
    is_active: true,
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const response = await api.get("/collaborators/departments");
        setDepartments(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Erro ao carregar departamentos:", error);
        setDepartments([]);
      }
    };

    loadDepartments();

    const loadManagers = async () => {
      try {
        const response = await api.get("/collaborators/listbox");
        setManagers(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Erro ao carregar gerentes:", error);
        setManagers([]);
      }
    };

    loadManagers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.first_name || !form.last_name) {
      alert("Nome e Sobrenome são obrigatórios.");
      return;
    }

    try {
      await api.post("/collaborators/", {
        ...form,
        department_id: form.department_id ? Number(form.department_id) : null,
        manager_id: form.manager_id ? Number(form.manager_id) : null,
        // Datas vazias precisam ir como null (string "" quebra o parser do backend → 422).
        birth_date: form.birth_date || null,
        hire_date: form.hire_date || null,
      });
      navigate("/collaborators");
    } catch (error) {
      console.error("Erro ao criar colaborador:", error.response?.data || error);
      alert("Erro ao salvar colaborador.");
    }
  };

  return (
    <Layout>
      <Card className="max-w-3xl mx-auto">
        <CardHeader>
          <h1 className="text-xl font-semibold text-gray-900">Novo Colaborador</h1>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-600">Nome *</label>
              <Input value={form.first_name} onChange={(e) => handleChange("first_name", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Sobrenome *</label>
              <Input value={form.last_name} onChange={(e) => handleChange("last_name", e.target.value)} />
            </div>

            <div className="md:col-span-2">
              <label className="text-sm text-gray-600">E-mail</label>
              <Input value={form.email} onChange={(e) => handleChange("email", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Departamento</label>
              <select
                value={form.department_id}
                onChange={(e) => {
                  const selected = departments.find((department) => String(department.id) === e.target.value);
                  setForm((prev) => ({
                    ...prev,
                    department_id: e.target.value,
                    department: selected?.name || "",
                    cost_center: selected?.cost_center || "",
                  }));
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              >
                <option value="">Selecione um departamento</option>
                {departments.map((department) => (
                  <option key={department.id} value={department.id}>
                    {department.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">Centro de custo</label>
              <Input value={form.cost_center} onChange={(e) => handleChange("cost_center", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Cargo</label>
              <Input value={form.job_title} onChange={(e) => handleChange("job_title", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Gerente (responde a)</label>
              <select
                value={form.manager_id}
                onChange={(e) => handleChange("manager_id", e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              >
                <option value="">Sem gerente</option>
                {managers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {`${m.first_name || ""} ${m.last_name || ""}`.trim()}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">País</label>
              <Input value={form.country} onChange={(e) => handleChange("country", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Nascimento</label>
              <Input type="date" value={form.birth_date} onChange={(e) => handleChange("birth_date", e.target.value)} />
            </div>

            <div>
              <label className="text-sm text-gray-600">Admissão</label>
              <Input type="date" value={form.hire_date} onChange={(e) => handleChange("hire_date", e.target.value)} />
            </div>

            <div className="md:col-span-2">
              <label className="text-sm text-gray-600">Status</label>
              <select
                value={form.is_active ? "true" : "false"}
                onChange={(e) => handleChange("is_active", e.target.value === "true")}
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              >
                <option value="true">Ativo</option>
                <option value="false">Inativo</option>
              </select>
            </div>

            <div className="md:col-span-2 flex justify-end gap-2 mt-4">
              <Button type="button" variant="outline" onClick={() => navigate("/collaborators")}>
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </Layout>
  );
};

export default NewCollaborator;
